import script from "./Usage.vue?vue&type=script&setup=true&lang=js"
export * from "./Usage.vue?vue&type=script&setup=true&lang=js"

import "./Usage.vue?vue&type=style&index=0&id=669be0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669be0e2"]])

export default __exports__